<template>
    <b-container>
        <b-row>
            <b-col lg="4" offset-lg="4" class="mt-5">
                <forgot-password-form class="shadow" />
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import ForgotPasswordForm from '@/components/ForgotPasswordForm.vue'

export default {
    name: 'ForgotPassword',
    components: {
        ForgotPasswordForm,
    },
}
</script>
